import React, { useState, useContext } from 'react';
import { AuthContext } from '../App';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';

const CreateTournamentPage = () => {
  const { API, user } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    name: '',
    date: '',
    type: 'daily',
    category: 'דרג א',
    max_players: 16,
    description: '',
    location: 'מרכז הטניס רעננה',
    start_time: '09:00',
    prizes: {
      first_place: 'גביע + שובר של 500 ₪ לקנייה באתר ווילסון ישראל',
      second_place: 'גביע + שובר של 250 ₪ לקנייה באתר ווילסון ישראל',
      third_place: '',
      consolation_winner: ''
    }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      
      // המרת תאריך לפורמט ISO
      const isoDate = new Date(formData.date + 'T' + formData.start_time + ':00').toISOString();
      
      const tournamentData = {
        ...formData,
        date: isoDate,
        max_players: parseInt(formData.max_players)
      };
      
      const response = await axios.post(
        `${API}/admin/tournaments/create`,
        tournamentData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success('תחרות נוצרה בהצלחה!');
      navigate(`/tournament/${response.data.id}`);
    } catch (error) {
      console.error('Error creating tournament:', error);
      toast.error(error.response?.data?.detail || 'שגיאה ביצירת תחרות');
    }
  };

  if (!user || !['shafirroy@icloud.com', 'shafirroy@gmail.com'].includes(user.email)) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="max-w-4xl mx-auto p-8 text-center">
          <h1 className="text-3xl font-bold text-red-600">🚫 גישה נדחתה</h1>
          <p className="text-xl mt-4">אזור זה מיועד למנהל בלבד</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto p-8">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl">➕ יצירת תחרות חדשה</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* שם התחרות */}
              <div>
                <label className="block text-sm font-bold mb-2">שם התחרות *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full p-3 border rounded"
                  placeholder="לדוגמה: תחרות יומית - דרג א"
                  required
                />
              </div>

              {/* סוג תחרות */}
              <div>
                <label className="block text-sm font-bold mb-2">סוג תחרות *</label>
                <select
                  value={`${formData.type}_${formData.max_players}`}
                  onChange={(e) => {
                    const val = e.target.value;
                    const [newType, maxStr] = val.split('_');
                    const maxPlayers = parseInt(maxStr);
                    const newPrizes = newType === 'daily' 
                      ? {
                          first_place: 'גביע + שובר של 500 ₪ לקנייה באתר ווילסון ישראל',
                          second_place: 'גביע + שובר של 250 ₪ לקנייה באתר ווילסון ישראל',
                          third_place: '',
                          consolation_winner: ''
                        }
                      : {
                          first_place: 'גביע + שובר של 1,000 ₪ לקנייה באתר ווילסון ישראל',
                          second_place: 'גביע + שובר של 500 ₪ לקנייה באתר ווילסון ישראל',
                          third_place: 'שובר של 250 ₪ לקנייה באתר ווילסון ישראל',
                          consolation_winner: ''
                        };
                    setFormData({...formData, type: newType, max_players: maxPlayers, prizes: newPrizes});
                  }}
                  className="w-full p-3 border rounded"
                >
                  <option value="daily_8">יומית (8 שחקנים)</option>
                  <option value="daily_16">יומית (16 שחקנים)</option>
                  <option value="knockout_32">נוקאאוט (32 שחקנים)</option>
                </select>
              </div>
              
              {/* תצוגת פרסים */}
              <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border-2 border-yellow-300 rounded-lg p-6">
                <h3 className="text-xl font-bold text-yellow-800 mb-4 flex items-center gap-2">
                  🏆 פרסים לתחרות זו
                </h3>
                {formData.type === 'daily' ? (
                  <div className="space-y-3">
                    <div className="bg-white rounded-lg p-4 border-2 border-yellow-400">
                      <div className="flex items-center gap-3">
                        <span className="text-4xl">🥇</span>
                        <div>
                          <div className="font-bold text-yellow-600 text-lg">מקום ראשון</div>
                          <div className="text-gray-700">גביע + שובר כספי בסך <strong className="text-green-600">500 ₪</strong></div>
                          <div className="text-sm text-gray-600">לקנייה באתר של ווילסון ישראל</div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-4 border-2 border-gray-300">
                      <div className="flex items-center gap-3">
                        <span className="text-4xl">🥈</span>
                        <div>
                          <div className="font-bold text-gray-600 text-lg">מקום שני</div>
                          <div className="text-gray-700">גביע + שובר כספי בסך <strong className="text-green-600">250 ₪</strong></div>
                          <div className="text-sm text-gray-600">לקנייה באתר של ווילסון ישראל</div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-3">
                    <div className="bg-white rounded-lg p-4 border-2 border-yellow-400">
                      <div className="flex items-center gap-3">
                        <span className="text-4xl">🥇</span>
                        <div>
                          <div className="font-bold text-yellow-600 text-lg">מקום ראשון</div>
                          <div className="text-gray-700">גביע + שובר כספי בסך <strong className="text-green-600">1,000 ₪</strong></div>
                          <div className="text-sm text-gray-600">לקנייה באתר של ווילסון ישראל</div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-4 border-2 border-gray-300">
                      <div className="flex items-center gap-3">
                        <span className="text-4xl">🥈</span>
                        <div>
                          <div className="font-bold text-gray-600 text-lg">מקום שני</div>
                          <div className="text-gray-700">גביע + שובר כספי בסך <strong className="text-green-600">500 ₪</strong></div>
                          <div className="text-sm text-gray-600">לקנייה באתר של ווילסון ישראל</div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-4 border-2 border-orange-300">
                      <div className="flex items-center gap-3">
                        <span className="text-4xl">🥉</span>
                        <div>
                          <div className="font-bold text-orange-600 text-lg">מקום שלישי</div>
                          <div className="text-gray-700">שובר כספי בסך <strong className="text-green-600">250 ₪</strong></div>
                          <div className="text-sm text-gray-600">לקנייה באתר של ווילסון ישראל</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* קטגוריה */}
              <div>
                <label className="block text-sm font-bold mb-2">קטגוריה *</label>
                <select
                  value={formData.category}
                  onChange={(e) => setFormData({...formData, category: e.target.value})}
                  className="w-full p-3 border rounded"
                >
                  <option value="דרג א">דרג א</option>
                  <option value="דרג ב">דרג ב</option>
                  <option value="דרג ג">דרג ג</option>
                  <option value="יחידים open">יחידים open</option>
                  <option value="זוגות open">זוגות open</option>
                  <option value="נשים">נשים</option>
                </select>
              </div>

              {/* תאריך ושעה */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold mb-2">תאריך התחרות *</label>
                  <input
                    type="date"
                    value={formData.date}
                    onChange={(e) => setFormData({...formData, date: e.target.value})}
                    className="w-full p-3 border rounded"
                    required
                  />
                  {formData.date && (
                    <p className="text-sm text-blue-600 mt-1">
                      יום {new Date(formData.date).toLocaleDateString('he-IL', { weekday: 'long' })}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-bold mb-2">תחילת משחקים *</label>
                  <input
                    type="time"
                    value={formData.start_time}
                    onChange={(e) => setFormData({...formData, start_time: e.target.value})}
                    className="w-full p-3 border rounded"
                    required
                  />
                </div>
              </div>

              {/* מיקום */}
              <div>
                <label className="block text-sm font-bold mb-2">מיקום</label>
                <input
                  type="text"
                  value={formData.location}
                  onChange={(e) => setFormData({...formData, location: e.target.value})}
                  className="w-full p-3 border rounded"
                />
              </div>

              {/* תיאור */}
              <div>
                <label className="block text-sm font-bold mb-2">תיאור</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  className="w-full p-3 border rounded"
                  rows="4"
                  placeholder="תיאור קצר של התחרות..."
                />
              </div>

              {/* כפתורים */}
              <div className="flex gap-4">
                <Button type="submit" className="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 text-lg">
                  ✅ צור תחרות
                </Button>
                <Button 
                  type="button" 
                  onClick={() => navigate(-1)}
                  variant="outline"
                  className="flex-1 py-3 text-lg"
                >
                  ביטול
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CreateTournamentPage;
